<template>
  <div>
    <!--<el-tabs v-model="active" v-if="name && formConfig.length > 0">-->
      <!--<el-tab-pane :label="name" name="properties">-->
        <!--<component :is="(selectNode.type||'').toLowerCase()" :config="selectNode.props"/>-->
      <!--</el-tab-pane>-->
      <!--<el-tab-pane label="表单权限设置" name="permissions">-->
        <!--<form-authority-config/>-->
      <!--</el-tab-pane>-->
    <!--</el-tabs>-->
    <!--<component :is="(selectNode.type||'').toLowerCase()" v-else :config="selectNode.props"/>-->
    <component :is="(selectNode.type||'').toLowerCase()" :config="selectNode.props"/>
  </div>
</template>

<script>
import Approval from './ApprovalNodeConfig'
import Task from './TaskNodeConfig'
import Condition from './ConditionNodeConfig'
import Inclusive from './InclusiveNodeConfig'
import Delay from './DelayNodeConfig'
import Cc from './CcNodeConfig'
import Concurrent from './ConcurrentNodeConfig'
import Trigger from './TriggerNodeConfig'
import FormAuthorityConfig from './FormAuthorityConfig'
import Root from './RootNodeConfig'
import Subprocess from './SubprocessNodeConfig'

export default {
  name: 'NodeConfig',
  inject: ['$workflow'],
  components: {
    Approval,
    Task,
    Condition,
    Inclusive,
    Trigger,
    Delay,
    Root,
    Cc,
    Concurrent,
    Subprocess,
    FormAuthorityConfig
  },
  data () {
    return {
      active: 'properties'
    }
  },
  computed: {
    selectNode () {
      return this.$workflow.selectedNode
    },
    formConfig () {
      return this.$workflow.design.formItems
    },
    name () {
      switch (this.selectNode.type) {
        case 'ROOT':
          return '设置发起人'
        case 'APPROVAL':
          return '设置审批人'
        case 'TASK':
          return '设置办理人'
        case 'CC':
          return '设置抄送人'
        default:
          return null
      }
    }
  }
}
</script>
